import axios from 'axios';
import {useMutation} from 'react-query';
import { toast } from 'react-toastify';

const useGetPdfSummaryReport = (projectId) => {
  const { mutateAsync, isLoading } = useMutation(async ({ projectId }) => {
    const config = {responseType: 'blob',};
    return await axios.get(`/standardization/${projectId}/report/summary`, config);
  });

  const getSummaryReport = async (projectId, options) => {
    mutateAsync(
        { projectId },
        {
          onSuccess: (res) => {
            toast.success("Successfully created summary pdf");
            const file = new Blob([res.data], {
              type: "application/pdf",
            });

            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
        }
    );
  };

  return {
    getSummaryReport,
    isLoading,
  };
};

export default useGetPdfSummaryReport;
